// This file is auto-generated. Do not edit directly.
// Generated from configuration/groups/sient/document-mappings.yaml
// Run: bun run scripts/mappings/sient-make-mappings-from-yaml.ts
import { DocumentMapping } from "@/configuration/document-mappings/types";
import { Classification } from "@/src/models/constants/classifications";

export const SIENT_MAPPINGS: Partial<Record<Classification, DocumentMapping>> = {
  [Classification.ADMIN]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "STAFF, FRONT OFFICE",
    displayName: "DOCS4DOCS",
    documentLabel: "{{ dateReceived YYYY-MM-DD }}, DOCS4DOCS",
    folder: "Administrative",
    folderMapping: "Administrative",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.ADMIN,
    group: "sient"
  },
  [Classification.ADMIN_CERTIFICATE_OF_MEDICAL_NECESSITY]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "RECEIVING PROVIDER",
    displayName: "PHYSICIAN AUTHORIZATIONS/CERTIFICATIONS",
    documentLabel: "{{ dateReceived YYYY-MM-DD }}, PHYSICIAN AUTHORIZATIONS/CERTIFICATIONS",
    folder: "Physician Authorization",
    folderMapping: "Physician Authorization",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Receiving Provider WF",
    classification: Classification.ADMIN_CERTIFICATE_OF_MEDICAL_NECESSITY,
    group: "sient"
  },
  [Classification.ADMIN_FMLA_FORMS]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "STAFF, FMLA",
    displayName: "FMLA",
    documentLabel: "{{ dateReceived YYYY-MM-DD }}, FMLA",
    folder: "FMLA",
    folderMapping: "FMLA",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.ADMIN_FMLA_FORMS,
    group: "sient"
  },
  [Classification.ADMIN_RETURN_TO_WORK]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "RETURN TO WORK / SCHOOL",
    documentLabel: "{{ dateReceived YYYY-MM-DD }}, RETURN TO WORK / SCHOOL",
    folder: "Letters",
    folderMapping: "Letters",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.ADMIN_RETURN_TO_WORK,
    group: "sient"
  },
  [Classification.ADMIN_SCHOOL_NOTES]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "RETURN TO WORK / SCHOOL",
    documentLabel: "{{ dateReceived YYYY-MM-DD }}, RETURN TO WORK / SCHOOL",
    folder: "Letters",
    folderMapping: "Letters",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.ADMIN_SCHOOL_NOTES,
    group: "sient"
  },
  [Classification.CARE_PLAN]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "RECEIVING PROVIDER",
    displayName: "PLAN OF CARE",
    documentLabel: "{{ dateReceived YYYY-MM-DD }}, PLAN OF CARE",
    folder: "Physician Authorization",
    folderMapping: "Physician Authorization",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Receiving Provider WF",
    classification: Classification.CARE_PLAN,
    group: "sient"
  },
  [Classification.CLEARANCE_REQUEST]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "REQUESTING PROVIDER",
    displayName: "MEDICAL CLEARANCE",
    documentLabel: "{{ dateReceived YYYY-MM-DD }}, MEDICAL CLEARANCE",
    folder: "Medical Clearance",
    folderMapping: "Medical Clearance",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.CLEARANCE_REQUEST,
    group: "sient"
  },
  [Classification.DME_REQUEST]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "STAFF, FRONT OFFICE",
    displayName: "DME_REQUEST",
    documentLabel: "{{ dateReceived YYYY-MM-DD }}, DME_REQUEST",
    folder: "Administrative",
    folderMapping: "Administrative",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.DME_REQUEST,
    group: "sient"
  },
  [Classification.FINANCIAL]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "STAFF, FRONT OFFICE",
    displayName: "FINANCIAL",
    documentLabel: "{{ dateReceived YYYY-MM-DD }}, FINANCIAL",
    folder: "Administrative",
    folderMapping: "Administrative",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.FINANCIAL,
    group: "sient"
  },
  [Classification.IDENTIFICATION_CARD]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "STAFF, FRONT OFFICE",
    displayName: "IDENTIFICATION_CARD",
    documentLabel: "{{ dateReceived YYYY-MM-DD }}, IDENTIFICATION_CARD",
    folder: "Administrative",
    folderMapping: "Administrative",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.IDENTIFICATION_CARD,
    group: "sient"
  },
  [Classification.IMAGING_RESULTS]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "RECEIVING PROVIDER",
    displayName: "IMAGING REPORTS",
    documentLabel: "{{ dateOfEvent YYYY-MM-DD }}, {{ type }}, {{ bodyPart }}",
    folder: "X-Ray Documents",
    folderMapping: "X-Ray Documents",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Receiving Provider WF",
    classification: Classification.IMAGING_RESULTS,
    group: "sient"
  },
  [Classification.IMAGING_RESULTS_BARIUM_SWALLOW]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "RECEIVING PROVIDER",
    displayName: "MODIFIED BARIUM SWALLOW",
    documentLabel: "{{ dateOfEvent YYYY-MM-DD }}, MODIFIED BARIUM SWALLOW, {{ bodyPart }}",
    folder: "X-Ray Documents",
    folderMapping: "X-Ray Documents",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Receiving Provider WF",
    classification: Classification.IMAGING_RESULTS_BARIUM_SWALLOW,
    group: "sient"
  },
  [Classification.IMAGING_RESULTS_CARDIAC]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "RECEIVING PROVIDER",
    displayName: "IMAGING REPORTS",
    documentLabel: "{{ dateOfEvent YYYY-MM-DD }}, {{ imagingType }}, {{ bodyPart }}",
    folder: "X-Ray Documents",
    folderMapping: "X-Ray Documents",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Receiving Provider WF",
    classification: Classification.IMAGING_RESULTS_CARDIAC,
    group: "sient"
  },
  [Classification.IMAGING_RESULTS_EKG]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "RECEIVING PROVIDER",
    displayName: "EKG",
    documentLabel: "{{ dateOfEvent YYYY-MM-DD }}, EKG, {{ bodyPart }}",
    folder: "Diagnostic Documents",
    folderMapping: "Diagnostic Documents",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Receiving Provider WF",
    classification: Classification.IMAGING_RESULTS_EKG,
    group: "sient"
  },
  [Classification.IMAGING_RESULTS_ENG]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "RECEIVING PROVIDER",
    displayName: "ENG/VNG",
    documentLabel: "{{ dateOfEvent YYYY-MM-DD }}, ENG/VNG, {{ bodyPart }}",
    folder: "Diagnostic Documents",
    folderMapping: "Diagnostic Documents",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Receiving Provider WF",
    classification: Classification.IMAGING_RESULTS_ENG,
    group: "sient"
  },
  [Classification.IMAGING_RESULTS_ESOPHAGRAM]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "RECEIVING PROVIDER",
    displayName: "ESOPHAGRAM",
    documentLabel: "{{ dateOfEvent YYYY-MM-DD }}, ESOPHAGRAM, {{ bodyPart }}",
    folder: "X-Ray Documents",
    folderMapping: "X-Ray Documents",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Receiving Provider WF",
    classification: Classification.IMAGING_RESULTS_ESOPHAGRAM,
    group: "sient"
  },
  [Classification.IMAGING_RESULTS_MRI]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "RECEIVING PROVIDER",
    displayName: "IMAGING REPORTS",
    documentLabel: "{{ dateOfEvent YYYY-MM-DD }}, MRI, {{ bodyPart }}",
    folder: "X-Ray Documents",
    folderMapping: "X-Ray Documents",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Receiving Provider WF",
    classification: Classification.IMAGING_RESULTS_MRI,
    group: "sient"
  },
  [Classification.IMAGING_RESULTS_ULTRASOUND]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "RECEIVING PROVIDER",
    displayName: "IMAGING REPORTS",
    documentLabel: "{{ dateOfEvent YYYY-MM-DD }}, ULTRASOUND, {{ bodyPart }}",
    folder: "X-Ray Documents",
    folderMapping: "X-Ray Documents",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Receiving Provider WF",
    classification: Classification.IMAGING_RESULTS_ULTRASOUND,
    group: "sient"
  },
  [Classification.IMAGING_RESULTS_X_RAY]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "RECEIVING PROVIDER",
    displayName: "IMAGING REPORTS",
    documentLabel: "{{ dateOfEvent YYYY-MM-DD }}, X RAY, {{ bodyPart }}",
    folder: "X-Ray Documents",
    folderMapping: "X-Ray Documents",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Receiving Provider WF",
    classification: Classification.IMAGING_RESULTS_X_RAY,
    group: "sient"
  },
  [Classification.INCOMPLETE]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "STAFF, FRONT OFFICE",
    displayName: "INCOMPLETE",
    documentLabel: "{{ dateReceived YYYY-MM-DD }}, INCOMPLETE",
    folder: "Administrative",
    folderMapping: "Administrative",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.INCOMPLETE,
    group: "sient"
  },
  [Classification.INSURANCE_CARD]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "STAFF, FRONT OFFICE",
    displayName: "INSURANCE_CARD",
    documentLabel: "{{ dateReceived YYYY-MM-DD }}, INSURANCE_CARD",
    folder: "Administrative",
    folderMapping: "Administrative",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.INSURANCE_CARD,
    group: "sient"
  },
  [Classification.LAB_RESULTS]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "RECEIVING PROVIDER",
    displayName: "LABS",
    documentLabel: "{{ collectionDate YYYY-MM-DD }}, {{ nameOfLab }}",
    folder: "Lab Documents",
    folderMapping: "Lab Documents",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Receiving Provider WF",
    classification: Classification.LAB_RESULTS,
    group: "sient"
  },
  [Classification.LAB_RESULTS_PATHOLOGY]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "RECEIVING PROVIDER",
    displayName: "PATHOLOGY REPORTS",
    documentLabel: "{{ collectionDate YYYY-MM-DD }}, PATHOLOGY REPORTS",
    folder: "Pathology Reports",
    folderMapping: "Pathology Reports",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Receiving Provider WF",
    classification: Classification.LAB_RESULTS_PATHOLOGY,
    group: "sient"
  },
  [Classification.LEGAL]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "STAFF, FRONT OFFICE",
    displayName: "LEGAL",
    documentLabel: "{{ dateReceived YYYY-MM-DD }}, LEGAL",
    folder: "Administrative",
    folderMapping: "Administrative",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.LEGAL,
    group: "sient"
  },
  [Classification.LEGAL_POWER_OF_ATTORNEY]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "STAFF, FRONT OFFICE",
    displayName: "LEGAL_POWER_OF_ATTORNEY",
    documentLabel: "{{ dateReceived YYYY-MM-DD }}, LEGAL_POWER_OF_ATTORNEY",
    folder: "Administrative",
    folderMapping: "Administrative",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.LEGAL_POWER_OF_ATTORNEY,
    group: "sient"
  },
  [Classification.MEDICAL_HISTORY]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "STAFF, MEDICAL RECORDS",
    displayName: "MEDICAL_HISTORY",
    documentLabel: "{{ dateReceived YYYY-MM-DD }}, MEDICAL_HISTORY",
    folder: "Historical Medical Records",
    folderMapping: "Historical Medical Records",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.MEDICAL_HISTORY,
    group: "sient"
  },
  [Classification.MEDICAL_RECORD_REQUEST]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "STAFF, MEDICAL RECORDS",
    displayName: "MEDICAL RECORDS REQUEST",
    documentLabel: "{{ dateReceived YYYY-MM-DD }}, MEDICAL RECORDS REQUEST",
    folder: "Medical Record Requests",
    folderMapping: "Medical Record Requests",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.MEDICAL_RECORD_REQUEST,
    group: "sient"
  },
  [Classification.NOTIFICATION_APPOINTMENT]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "STAFF, FRONT OFFICE",
    displayName: "APPONTMENT COMFIRMATION",
    documentLabel: "{{ dateReceived YYYY-MM-DD }}, APPONTMENT COMFIRMATION",
    folder: "Administrative",
    folderMapping: "Administrative",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.NOTIFICATION_APPOINTMENT,
    group: "sient"
  },
  [Classification.NOTIFICATION_APPOINTMENT_CANCELLED_MISSED]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "STAFF, FRONT OFFICE",
    displayName: "APPOINTMENT NOTIFICATIONS",
    documentLabel: "{{ dateReceived YYYY-MM-DD }}, APPOINTMENT NOTIFICATIONS",
    folder: "Administrative",
    folderMapping: "Administrative",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.NOTIFICATION_APPOINTMENT_CANCELLED_MISSED,
    group: "sient"
  },
  [Classification.PHARMACY_RELATED_REFILL]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "RECEIVING PROVIDER",
    displayName: "PRESCRIPTION REFILL REQUEST",
    documentLabel: "{{ dateReceived YYYY-MM-DD }}, PRESCRIPTION REFILL REQUEST",
    folder: "Prescriptions",
    folderMapping: "Prescriptions",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Receiving Provider WF",
    classification: Classification.PHARMACY_RELATED_REFILL,
    group: "sient"
  },
  [Classification.PRIOR_AUTHORIZATION]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "STAFF, FRONT OFFICE",
    displayName: "PRIOR AUTHORIZATION",
    documentLabel: "{{ dateReceived YYYY-MM-DD }}, PRIOR AUTHORIZATION",
    folder: "Administrative",
    folderMapping: "Administrative",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PRIOR_AUTHORIZATION,
    group: "sient"
  },
  [Classification.PRIOR_AUTHORIZATION_MEDICATION_REQUEST]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "HENRIKSON, CANDACE",
    displayName: "MEDICATION / PRESCRIPTION PRIOR AUTH",
    documentLabel: "{{ dateReceived YYYY-MM-DD }}, MEDICATION / PRESCRIPTION PRIOR AUTH",
    folder: "Prescriptions",
    folderMapping: "Prescriptions",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PRIOR_AUTHORIZATION_MEDICATION_REQUEST,
    group: "sient"
  },
  [Classification.PRIOR_AUTHORIZATION_MEDICATION_RESPONSE]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "STAFF, FRONT OFFICE",
    displayName: "PRESCRIPTION PRIOR AUTH RESPONSE",
    documentLabel: "{{ dateReceived YYYY-MM-DD }}, PRESCRIPTION PRIOR AUTH",
    folder: "Insurance Approvals",
    folderMapping: "Insurance Approvals",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PRIOR_AUTHORIZATION_MEDICATION_RESPONSE,
    group: "sient"
  },
  [Classification.PRIOR_AUTHORIZATION_PROCEDURE_REQUEST]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "STAFF, FRONT OFFICE",
    displayName: "AUTHORIZATION REQUEST - OFFICE VISITS / IMAGING / SURGERY",
    documentLabel: "{{ dateReceived YYYY-MM-DD }}, AUTHORIZATION REQUEST - {{ documentType }}",
    folder: "Insurance Approvals",
    folderMapping: "Insurance Approvals",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PRIOR_AUTHORIZATION_PROCEDURE_REQUEST,
    group: "sient"
  },
  [Classification.PRIOR_AUTHORIZATION_PROCEDURE_RESPONSE]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "STAFF, FRONT OFFICE",
    displayName: "INSURANCE AUTHORIZATION RESPONSE",
    documentLabel: "{{ dateReceived YYYY-MM-DD }}, INSURANCE AUTHORIZATIONS - {{ documentType }}",
    folder: "Insurance Approvals",
    folderMapping: "Insurance Approvals",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PRIOR_AUTHORIZATION_PROCEDURE_RESPONSE,
    group: "sient"
  },
  [Classification.PROCEDURE_REHAB]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "RECEIVING PROVIDER",
    displayName: "OUTPATIENT SPEECH THERAPY",
    documentLabel: "{{ dateOfEvent YYYY-MM-DD }}, OUTPATIENT SPEECH THERAPY",
    folder: "Consult Notes",
    folderMapping: "Consult Notes",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Receiving Provider WF",
    classification: Classification.PROCEDURE_REHAB,
    group: "sient"
  },
  [Classification.PROCEDURE_SLEEP]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "RECEIVING PROVIDER",
    displayName: "SLEEP STUDIES",
    documentLabel: "{{ dateOfEvent YYYY-MM-DD }}, SLEEP STUDIES",
    folder: "Diagnostic Documents",
    folderMapping: "Diagnostic Documents",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Receiving Provider WF",
    classification: Classification.PROCEDURE_SLEEP,
    group: "sient"
  },
  [Classification.PROGRESS_NOTE]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "RECEIVING PROVIDER",
    displayName: "CONSULT NOTES",
    documentLabel: "{{ dateOfEvent YYYY-MM-DD }}, CONSULT NOTES",
    folder: "Consult Notes",
    folderMapping: "Consult Notes",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Receiving Provider WF",
    classification: Classification.PROGRESS_NOTE,
    group: "sient"
  },
  [Classification.PROGRESS_NOTE_HOSPITAL_DISCHARGE_SUMMARY]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "RECEIVING PROVIDER",
    displayName: "DISCHARGE SUMMARIES",
    documentLabel: "{{ dateOfEvent YYYY-MM-DD }}, DISCHARGE SUMMARIES",
    folder: "Discharge Summaries",
    folderMapping: "Discharge Summaries",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Receiving Provider WF",
    classification: Classification.PROGRESS_NOTE_HOSPITAL_DISCHARGE_SUMMARY,
    group: "sient"
  },
  [Classification.PROGRESS_NOTE_HOSPITAL_RECORDS]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "RECEIVING PROVIDER",
    displayName: "HOSPITAL VISITS - INPATIENT / OUTPATIENT / ED VISITS",
    documentLabel: "{{ dateOfEvent YYYY-MM-DD }}, HOSPITAL VISITS - INPATIENT / OUTPATIENT / ED VISITS",
    folder: "Hospital Visits – Inpatient / Outpatient / Ed Visits",
    folderMapping: "Hospital Visits – Inpatient / Outpatient / Ed Visits",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Receiving Provider WF",
    classification: Classification.PROGRESS_NOTE_HOSPITAL_RECORDS,
    group: "sient"
  },
  [Classification.PROGRESS_NOTE_OPERATIVE_REPORT]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "RECEIVING PROVIDER",
    displayName: "OPERATIVE REPORTS",
    documentLabel: "{{ dateOfEvent YYYY-MM-DD }}, OPERATIVE REPORTS",
    folder: "OP Reports",
    folderMapping: "OP Reports",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Receiving Provider WF",
    classification: Classification.PROGRESS_NOTE_OPERATIVE_REPORT,
    group: "sient"
  },
  [Classification.REFERRAL]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "STAFF, REFERRALS",
    displayName: "REFERRALS",
    documentLabel: "{{ dateOfReferral YYYY-MM-DD }}, REFERRALS",
    folder: "Referral Notes",
    folderMapping: "Referral Notes",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Inbound Referral WF",
    classification: Classification.REFERRAL,
    group: "sient"
  },
  [Classification.REFERRAL_REQUEST]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "STAFF, FRONT OFFICE",
    displayName: "REFERRAL REQUEST",
    documentLabel: "{{ dateReceived YYYY-MM-DD }} REFERRAL REQUEST",
    folder: "Administrative",
    folderMapping: "Administrative",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.REFERRAL_REQUEST,
    group: "sient"
  },
  [Classification.UNKNOWN]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "STAFF, FRONT OFFICE",
    displayName: "UNKNOWN",
    documentLabel: "{{ dateReceived YYYY-MM-DD }}, UNKNOWN",
    folder: "Administrative",
    folderMapping: "Administrative",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.UNKNOWN,
    group: "sient"
  }
} as const;
